import ajax from '@/utils/ajax'

/**
 * @module 公用接口
 */

 const BASE_URL = 'gasInfo/'

// 获取省列表
export const getProvinceList = () => ajax.post(`${BASE_URL}getProvinceList`)

// 获取市区列表
export const getCityList = params => ajax.post(`${BASE_URL}queryCityInfoByCode`, params)

// 查询金盾权限
export const getGoldenRight = () => ajax.post('gasInfo/getIfGoldenShield')

// 获取全局信息
export const getUnReadMsgCount = (params) => ajax.post(`messageCenter/messageNewManage/getUnReadMsgCount`, params)

// 联系我们接口
export const getGasContractorInfo = (params) => ajax.post('customer/getGasContractorInfo', params)

// 判断是加油加气油站
export const getStationEnergyType = params => ajax.post(`${BASE_URL}getStationEnergyType`, params)

// // 油站学堂跳转回调链接
// export const getXetIndexUrl = params => ajax.post('/starlink/school/getXetIndexUrl', params)

// // 油站学堂登录地址接口
// export const registerAndLoginXet = params => ajax.post('/starlink/school/registerAndLoginXet', params)

export const registerAndLoginXet = params => ajax.post('/starlink/school/registerAndLoginXet', params)

// 获取cos凭证
export const credential = params => ajax.post('/order/get/cos/tmp/credential', params)

// 获取oss凭证
export const getOssToken = params => ajax.post('/common/getTemporaryOssAccess', params)

// 获取cos凭证（weber-imgs bucket）
export const getCosToken = params => ajax.post('/cosAccess/temporaryToken', params)

// 是否同意自动退款
export const isAgreeCheck = params => ajax.post('/activity/agreement/check', params)

// 签署自动退款协议
export const agreeCheck = params => ajax.post('/activity/agreement/accept', params)

// 阅读规则
export const readRule = params => ajax.post('/login/read', params)
